import { Bounce, ToastContainer } from 'react-toastify';

// React 19 no longer applies `defaultProps` to function components. react-toastify
// v9's `ToastContainer` supplies its defaults (notably the `transition` component)
// via `defaultProps`, so under React 19 `transition` becomes `undefined` and rendering
// a toast calls `createElement(undefined)` — throwing "Element type is invalid".
// Re-apply react-toastify v9's `ToastContainer` defaults explicitly to preserve behavior.
// Upgrade to v11 in separate PR.
export const AppToastContainer = () => (
  <ToastContainer
    autoClose={5000}
    closeOnClick
    draggable
    draggableDirection="x"
    draggablePercent={80}
    pauseOnFocusLoss
    pauseOnHover
    position="top-right"
    role="alert"
    theme="light"
    transition={Bounce}
  />
);
